<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title>
        <v-select
          v-model="typeId"
          :items="types"
          item-value="id"
          item-text="add"
          solo
          flat
          hide-details
          class="min-width"
        />
      </v-card-title>
      <v-card-subtitle> This is the start of something creative. </v-card-subtitle>
      <v-card-text>
        <CategoryAdd
          v-if="typeId == 'categories'"
          ref="category"
        />
        <IndustryAdd
          v-if="typeId == 'industries'"
          ref="industry"
        />
        <TopicAdd
          v-if="typeId == 'topics'"
          ref="topic"
        />
        <TemplatesAdd
          v-if="typeId == 'templates'"
          ref="template"
        />
        <DesignGroupsAdd
          v-if="typeId == 'designgroups'"
          ref="designgroup"
        />
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Add
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import TemplatesAdd from '@/components/templates/Add';
import DesignGroupsAdd from '@/components/designgroups/Add';
import IndustryAdd from '@/components/industries/Add';
import TopicAdd from '@/components/topics/Add';
import CategoryAdd from '@/components/categories/Add';
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogAddDrawer',
  components: {
    TemplatesAdd,
    DesignGroupsAdd,
    IndustryAdd,
    TopicAdd,
    CategoryAdd
  },
  data() {
    return {
      typeId: '',
      valid: false,
      drawer: false,
      saving: false
    };
  },
  computed: {
    types() {
      return this.$enums.CATALOG_TABS.filter((x) => !!x.add);
    },
    ...mapGetters({})
  },
  mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.CATALOG_ADD_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.CATALOG_ADD_SHOW, (data) => {
      this.typeId = data.typeId;
      this.drawer = true;
    });

    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.CATALOG_ADD_HIDE);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.CATALOG_ADD_HIDE, () => {
      this.drawer = false;
    });
  },
  methods: {
    save() {
      switch (this.typeId) {
        case 'templates':
          this.$refs.template.save();
          break;
        case 'designgroups':
          this.$refs.designgroup.save();
          break;
        case 'industries':
          this.$refs.industry.save();
          break;
        case 'topics':
          this.$refs.topic.save();
          break;
        case 'categories':
          this.$refs.category.save();
          break;
      }
    }
  }
};
</script>
